import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

const BlacklistedArtist = ({id, is_blacklisted, tooltipPlacement="top"}) => {
  const tooltipId = `blacklisted-tooltip-${id}`;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const tooltipText = is_blacklisted
    ? "This artist is blacklisted and not eligible for distribution."
    : "This artist is not blacklisted and eligible for distribution.";
  const iconColor = is_blacklisted ? 'danger' : 'success';

  return (
    <div 
        key={id}
        id={tooltipId}
        className={`mdi mdi-flag mdi-36px text-${iconColor}`}
        style={{ cursor: 'pointer' }}
    >
      <Tooltip
        placement={tooltipPlacement}
        isOpen={tooltipOpen}
        target={tooltipId}
        toggle={toggle}
      >
        {tooltipText}
      </Tooltip>
    </div>
  );
};

export default BlacklistedArtist;